<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3 v-if="this.project">Project - {{ project.name }}</h3>
            </b-col>
        </b-row>

        <div v-if="this.project">

            <b-row class="mb-3">
                <b-col md="2">
                    Space
                </b-col>
                <b-col md="4">
                    <router-link :to="'/space/' + this.project.space_uuid">{{ this.project.space_name }}</router-link>
                </b-col>
                <b-col md="2">
                    Clone project to
                </b-col>
                <b-col md="3">
                    <ejs-dropdownlist id='dropdownlist' placeholder='Start typing the name of the space'
                        :allowFiltering='true' :filtering="filtering" :dataSource='list_of_spaces'
                        :fields='space_select_fields' v-model='spaceToClone'>
                    </ejs-dropdownlist>
                </b-col>
                <b-col md="1">
                    <b-button :disabled="!spaceToClone" variant="success" @click="cloneProject()">
                        Clone
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col md="2">
                    Created by
                </b-col>
                <b-col md="4">
                    {{ this.project.created_by }}
                </b-col>
                <b-col md="2">
                    Create project prototype to
                </b-col>
                <b-col md="3">
                    <ejs-dropdownlist id='dropdownlist' placeholder='Select from the list' :allowFiltering='true'
                        :filtering="filtering" :dataSource='list_of_space_prototypes' :fields='space_select_fields'
                        v-model='SpacePrototypeTarget'>
                    </ejs-dropdownlist>
                </b-col>
                <b-col md="1">
                    <b-button :disabled="!SpacePrototypeTarget" variant="success" @click="CreateProjectPrototype()">
                        Create
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col md="2">
                    Nbr. of smartboards
                </b-col>
                <b-col md="9">
                    {{ this.project.number_of_smartboards }}
                </b-col>
            </b-row>

            <b-form @submit="onSubmit">
                <b-form-group label-cols-lg="2" label="Name" label-for="input-title">
                    <b-form-input id="input-title" v-model="project.name"></b-form-input>
                </b-form-group>

                <b-form-group label-cols-lg="2" label="Description" label-for="input-title">
                    <b-form-input id="input-title" v-model="project.description"></b-form-input>
                </b-form-group>

                <b-form-group label-cols-lg="2" label="Is public" label-for="input-is-public">
                    <b-form-checkbox class="col-form-label" id="input-is-public" v-model="project.is_public" />
                </b-form-group>

                <b-form-group label-cols-lg="2" label="Is demo" label-for="input-is-sandbox">
                    <b-form-checkbox class="col-form-label" id="input-is-sandbox" v-model="project.is_sandbox" />
                </b-form-group>

                <b-form-group label-cols-lg="2" label="Is unlisted" label-for="input-is-unlisted">
                    <b-form-checkbox class="col-form-label" id="input-is-unlisted" v-model="project.unlisted" />
                </b-form-group>

                <b-form-group label-cols-lg="2" label="Is auto_load" label-for="input-is-auto_load">
                    <b-form-checkbox class="col-form-label" id="input-is-auto_load" v-model="project.auto_load" />
                </b-form-group>

                <b-button :disabled="upload_data" type="submit" variant="primary">Update project details <b-spinner
                        v-if="upload_data" small label="Loading..." /></b-button>
                <b-button :disabled="upload_data" variant="danger" class="float-right" @click="deleteProject">Delete project
                    <b-spinner v-if="upload_data" small label="Loading..." /> </b-button>
            </b-form>

            <div class="my-3">
                <h4>Users</h4>
                <b-container>
                    <b-row>
                        <b-col>
                            <b-button :disabled="!userEmail || !user_permission" variant="success" @click="submitNewUser()"
                                class="mb-3">
                                Add user
                            </b-button>
                        </b-col>
                        <b-col cols="8">
                            <ejs-dropdownlist id='dropdownlist' placeholder='User email' :allowFiltering='true'
                                :dataSource='list_of_users' :fields='user_select_fields' v-model='userEmail'>
                            </ejs-dropdownlist>
                        </b-col>
                        <b-col>
                            <ejs-dropdownlist id='dropdownlist' placeholder='Permission' :dataSource='list_of_permission'
                                :fields='permission_fields' v-model='user_permission'></ejs-dropdownlist>
                        </b-col>
                    </b-row>
                </b-container>

                <b-table id="my-table-users" :fields="user_fields" :items="project.shared_with" :per-page="perPage"
                    :current-page="currentPageUser" small striped>
                    <template v-slot:cell(email)="data">
                        <router-link :to="'/user/' + data.item.uuid">{{ data.value }}</router-link>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-icon-trash-fill class="text-danger align-middle mr-2" font-scale="1.5"
                            @click="remove_user_from_project(data.item)" />
                    </template>
                </b-table>
                <b-pagination v-model="currentPageUser" :total-rows="project.shared_with.length" :per-page="perPage"
                    align="fill" size="sm" class="my-0" />

            </div>

            <div class="my-3">

                <h4>Placeholders</h4>
                <b-table id="my-table-groups" :items="project.smartboards" :per-page="perPage"
                    :current-page="currentPageGroup" :fields="placeholder_fields" small striped>
                    <template v-slot:cell(content)="data">
                        <div v-if="['link', 'customlink'].includes(data.item.content_type)">
                            <a :href="data.item.url" target="_blank">
                                {{ data.item.url.slice(0, 100) }}
                                <label v-if="data.item.url.length > 100">...</label>
                            </a>
                            <i class="far fa-clone px-2 " @click="copy(data.item.url)" @mouseover="clearTooltip"
                                :id="'tooltip-target' + data.index"></i>
                            <b-tooltip :target="'tooltip-target' + data.index" triggers="hover">
                                {{ copyMessage }}
                            </b-tooltip>
                        </div>
                        <div class="iframeClass" v-else-if="['image', 'pdf'].includes(data.item.content_type)"
                            @click="showContent(data.item)">
                            <img v-if="data.item.content_type == 'image'" :src="data.item.url" frameborder="0" style="pointer-events:none;">
                            <iframe v-else :src="data.item.url" frameborder="0" style="pointer-events:none;"></iframe>
                        </div>
                        <div v-else-if="data.item.content_type == 'file'">
                            <iframe :src="data.item.url" frameborder="0"></iframe>
                        </div>
                        <div v-else-if="data.item.content_type == 'image/svg+xml'">
                            <div v-html="data.item.string"></div>
                        </div>

                    </template>

                    <template v-slot:cell(client_type)="data">
                        {{ data.value }} - {{ data.item.content_type }}
                    </template>

                    <template v-slot:cell(embeddable)="data">
                        <label v-if="data.item.webmw_embeddable">&#9989;</label>
                        <label v-else-if="data.item.webmw_embeddable == false">&#10060;</label>
                    </template>
                </b-table>
            </div>

        </div>

        <b-modal id="modalContent" size="xl" ok-only scrollable>
            <div v-if="content">
                <div v-html="content" id="app"></div>
            </div>
        </b-modal>

    </b-container>
</template>

<style>
iframe.w-100 {
    min-height: 75vh;
}

.fa-clone,
.iframeClass {
    cursor: pointer;
}

#my-table-groups svg {
    width: 50%;
    height: 50%;
}

#my-table-groups img {
    max-width: 30%;
    max-height: 30%;
}
</style>


<script>
import Alert from '../components/alert.vue';
import { BIconTrashFill } from 'bootstrap-vue';

export default {
    data() {
        return {
            content: null,
            message: '',
            project: null,
            userEmail: null,
            spaceToClone: null,
            perPage: 20,
            currentPageUser: 1,
            currentPageGroup: 1,
            upload_data: null,
            user_fields: [
                { key: 'email', label: 'Email', class: 'text-center align-middle' },
                { key: 'permission', label: 'Permission', class: 'text-center align-middle' },
                { key: 'actions', label: 'Actions', class: 'text-center align-middle' }
            ],
            user_select_fields: { text: "email", value: "email" },
            space_select_fields: { text: "name", value: "uuid" },
            placeholder_fields: [
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'client_type', label: 'Client Type', class: 'text-center align-middle' },
                { key: 'content', label: 'Content', class: 'text-center align-middle' },
                { key: 'embeddable', label: 'Embeddable', class: 'text-center align-middle' },
            ],
            list_of_users: [],
            list_of_spaces: [],
            list_of_permission: [
                { text: 'Viewer', value: 1 },
                { text: 'Editor', value: 2 },
                { text: 'Admin', value: 3 },
                { text: 'Owner', value: 4 }
            ],
            permission_fields: { text: "text", value: "value" },
            user_permission: null,
            group_permission: null,
            list_of_space_prototypes: null,
            SpacePrototypeTarget: null,
            copyMessage: "Copy content url"
        }
    },
    components: {
        BIconTrashFill,
        alert: Alert,
    },
    methods: {
        filtering(e) {
            if (e.text.length >= 3) {
                this.download_spaces(e.text)
            }
        },
        init() {
            this.download_project_details();
            this.download_users();
            this.download_space_prototypes();
        },
        download_users() {
            this.$http.post(this.$apiURL + '/admin/users',
                {}, {
                headers: this.$store.getters.authHeader
            })
                .then((resp) => {
                    this.list_of_users = resp.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data.message,
                        'type': "danger"
                    }
                });
        },
        download_project_details() {
            this.$http.get(this.$apiURL + '/project/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.project = res.data
                    this.download_space_details()
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_space_details() {
            this.$http.get(this.$apiURL + '/space/' + this.project.space_uuid + "/download", { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.SpacePrototypeTarget = res.data.prototype_uuid
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_space_prototypes() {
            this.$http.get(this.$apiURL + '/admin/prototypes', { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.list_of_space_prototypes = res.data
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        download_spaces(filter) {
            this.$http.get(this.$apiURL + '/spaces/search',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: filter }
                })
                .then((res) => {
                    this.list_of_spaces = res.data.items
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                });
        },
        submitNewUser() {
            this.$http.post(this.$apiURL + '/project/' + this.$route.params.uuid + '/share', [{ email: this.userEmail, permission_id: this.user_permission }], { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.userEmail = null
                    this.user_permission = null
                    this.message = { 'message': "User has been set." }
                    this.init();
                })
                .catch((error) => {
                    this.message = {
                        'message': error.response.data,
                        'type': "danger"
                    }

                });
        },
        remove_user_from_project(row) {
            this.$dialog
                .confirm("Are you sure about the delete of the user?")
                .then(() => {
                    this.$http.delete(this.$apiURL + '/project/' + this.$route.params.uuid + '/share', { headers: this.$store.getters.authHeader, data: [{ email: row.email, permission_id: row.permission_id }] }
                    )
                        .then((res) => {
                            this.message = {
                                'message': "You removed user '" + row.email + "' succesfully!",
                                'type': "danger"
                            }
                            this.download_project_details()
                        })
                        .catch((error) => {
                            this.message = {
                                'message': error,
                                'type': "danger"
                            }
                        });
                });
        },
        cloneProject() {
            this.$http.post(this.$apiURL + '/admin/project/' + this.$route.params.uuid + '/clone', { space_uuid: this.spaceToClone }, { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.message = {
                        'message': "The project clone was succesfully!",
                    }
                    this.message.link = "/space/" + this.spaceToClone
                    this.spaceToClone = null;
                })
                .catch((error) => {
                    console.log(error.response.data.message)
                    this.message = error.response.data
                    this.message.type = "danger"
                });
        },
        CreateProjectPrototype() {
            let prototypeName = prompt("Please enter the name of the new project prototype.");
            if (prototypeName == null || prototypeName == "") {
                alert("Project prototype generation has been cancelled.")
            }
            else {
                this.$http.post(this.$apiURL + '/admin/project/' + this.$route.params.uuid + '/project_prototype', { space_prototype_uuid: this.SpacePrototypeTarget, name: prototypeName }, { headers: this.$store.getters.authHeader }
                )
                    .then((res) => {
                        this.message = {
                            'message': "The project prototype generation was success!",
                        }
                        this.message.link = "/prototype/" + this.SpacePrototypeTarget
                        this.SpacePrototypeTarget = null;
                    })
                    .catch((error) => {
                        console.log(error.response.data.message)
                        this.message = error.response.data
                        this.message.type = "danger"
                    });
            }
        },
        onSubmit(event) {
            event.preventDefault()
            this.upload_data = true;
            this.$http.patch(this.$apiURL + '/project/' + this.$route.params.uuid, {
                name: this.project.name,
                is_sandbox: this.project.is_sandbox,
                is_public: this.project.is_public,
                unlisted: this.project.unlisted,
                description: this.project.description,
                auto_load: this.project.auto_load
            },
                { headers: this.$store.getters.authHeader }
            )
                .then((res) => {
                    this.message = { 'message': "Project has been updated!" }
                    this.init();
                })
                .catch((error) => {
                    this.message = error.response.data
                    this.message.type = "danger"
                })
                .finally(() => {
                    this.upload_data = false;
                });
        },
        deleteProject() {
            this.$dialog
                .confirm("Are you sure about the delete of the project?")
                .then(() => {
                    this.upload_data = true;
                    this.$http.delete(this.$apiURL + '/project/' + this.$route.params.uuid, { headers: this.$store.getters.authHeader }
                    )
                        .then((res) => {
                            this.$router.push({ name: "space", params: { uuid: this.project.space_uuid, message: "Project has been removed!" } })
                        })
                        .catch((error) => {
                            console.log(error)
                            this.message = JSON.parse(error.request.response)
                            this.message.type = "danger"
                        })
                        .finally(() => {
                            this.upload_data = false;
                        });

                });
        },
        showContent(data) {
            if (data.content_type != 'image/svg+xml') {
                this.$http.get(this.$apiURL + '/smartboard/' + data.uuid, { headers: this.$store.getters.authHeader }
                )
                    .then((res) => {
                        this.content = res.data
                    })
                    .catch((error) => {
                        console.log(error)
                        this.message = JSON.parse(error.request.response)
                        this.message.type = "danger"
                    })
            }
            else {
                this.content = data.string;
            }

            this.$bvModal.show('modalContent')

        },
        async copy(link) {
            navigator.clipboard.writeText(link);
            this.copyMessage = "Copied!"
        },
        async clearTooltip() {
            this.copyMessage = "Copy content url"
        }
    },
    created() {
        this.init();
    },
}
</script>
